<template>
  <div class="singleConfig">
    <form class="uk-form-stacked uk-flex-center uk-flex">
      <div class="">
        <label class="uk-form-label">Budget</label>
        <input
          class="uk-input"
          :value="config.budget"
          type="number"
          v-on:input="update('budget', $event.target.value)"
        />
      </div>
      <div class="uk-margin-left">
        <label class="uk-form-label">CPS</label>
        <input
          class="uk-input"
          :value="config.CPS"
          type="number"
          v-on:input="update('CPS', $event.target.value)"
        />
      </div>
      <div class="uk-margin-left">
        <label class="uk-form-label">Trial Conversion</label>
        <input
          class="uk-input"
          :value="config.trialConversion"
          type="number"
          v-on:input="update('trialConversion', $event.target.value)"
        />
      </div>
      <div class="uk-margin-left">
        <label class="uk-form-label">Monthly Churn</label>
        <input
          class="uk-input"
          :value="config.churn"
          type="number"
          v-on:input="update('churn', $event.target.value)"
        />
      </div>
      <div class="uk-margin-left">
        <label class="uk-form-label">Organic Signups</label>
        <input
          class="uk-input"
          :value="config.signUpsOrganic"
          type="number"
          v-on:input="update('signUpsOrganic', $event.target.value)"
        />
      </div>
    </form>

    <ul uk-accordion="multiple: true">
      <li class="">
        <a class="uk-accordion-title uk-text-small" href="#">Additional</a>
        <div class="uk-accordion-content">
          <div class="uk-container">
            
          </div>
          <div class="uk-container">
            <button
              v-on:click="removeConfig(id)"
              class="uk-button  uk-align-right uk-button-alert uk-button-small"
            >
              Remove this set
            </button>
          </div>
        </div>
      </li>
    </ul>
    <br />
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "SingleConfig",
  props: {
    id: String
  },
  methods: {
    ...mapActions({
      updateConfig: "churn/updateConfig",
      removeConfig: "churn/removeConfig"
    }),
    update(field, value) {
      let o = {
        id: this.id
      };
      o[field] = value;
      this.updateConfig(o);
    }
  },
  computed: {
    ...mapGetters({
      getConfigById: "churn/getConfigByID"
      // ...
    }),
    config() {
      if (this.getConfigById) {
        return this.getConfigById(this.id);
      }
      return {};
    }
  }
};
</script>
